import type { Box } from 'models/Box';
import { closeModal } from 'xstate/actors/ModalActor';
import EmailInvitations from './EmailInvitations';
import LinkInvitations from './LinkInvitations';
import MemberList from './MemberList';
import { styles } from './styles';
import Button from 'elements/Button';
import Divider from 'elements/Divider';
import { useTranslations } from 'next-intl';

interface ManageAccessFormProps {
  box: Box;
}

const ManageAccessForm = ({ box }: ManageAccessFormProps) => {
  const t = useTranslations();

  return (
    <div className={styles.container}>
      <p className={styles.title.natural}>{t('boxSharing.sharedWith')}</p>

      <MemberList box={box} />

      <Divider className="mb-4" />

      <EmailInvitations box={box} />

      <LinkInvitations box={box} />

      <div className="flex justify-end mt-6">
        <Button
          type="button"
          size="sm"
          className="bg-mf-blue px-6 hover:bg-mf-blue-600 active:bg-mf-blue-700"
          onClick={closeModal}
        >
          {t('common.done')}
        </Button>
      </div>
    </div>
  );
};

export default ManageAccessForm;
